// @ vendors
const React = require('react');
const PropTypes = require('prop-types');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { toFirstUppercase } = require('utilities/stringHelper');

// @ components
const InsuranceRequestWizardPricing = require('../insuranceRequestWizardPricing/insuranceRequestWizardPricing')

// @ commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');

// @ constants
const { PAYMENT_TYPE } = require('../../../insuranceConstants/insuranceRequestHome');


const InsuranceRequestBuildPaymentType = ({
    paymentSelected,
    immInsuranceState,
    immInsuranceWizardStep,
    isRelated,
    onhandlePaymentTypeChange,
    buildError,
    isRnc,
    resetPlan
}) => {
    if (isRelated && !immInsuranceState.get('hasFetched') || immInsuranceWizardStep.get('isFetchingPricing')) {
        return (
            <section className="insurance-request-build-payment-type__loader">
                <LoadingSection />
            </section>
        );
    }
    const paymentType = immInsuranceWizardStep.get('paymentType');
    const planKey = isRnc ? immInsuranceWizardStep.get('insurancePlan') : immInsuranceState.getIn(['data', 'insurancePlan']);
    const planKeyLowerCase = planKey && planKey.toLowerCase()

    function buildPricingSection(paymentType) {
        const immPricing = immInsuranceWizardStep.get('pricing');
        const isLoading = !immInsuranceState.get('hasFetched') || immInsuranceWizardStep.get('isFetchingPricing');
        const insurancePlan = isRnc ? immInsuranceWizardStep.get('insurancePlan') : immInsuranceState.getIn(['data', 'insurancePlan'])
        return (
            <InsuranceRequestWizardPricing
                immPricing={immPricing}
                plan={insurancePlan}
                paymentType={paymentType}
                isRelated={isRelated}
                isLoading={isLoading}
            />
        );
    }

    const paymentOptions = Object.values(PAYMENT_TYPE).map((paymentTypeKey, idx) => {
        const price = immInsuranceWizardStep.getIn(['pricing', paymentTypeKey.toLowerCase(), planKeyLowerCase]);
        if (price) {
            return (
                <RadioButton
                    key={idx}
                    label={formatText(`insuranceRequestHome-step4paymentType${toFirstUppercase(paymentTypeKey)}`)}
                    value={paymentTypeKey}
                />
            );
        }
    }).filter(option => !!option);

    const paymentSectionRelated = (
        <div className="insurance-request-wizard-step-four__payment-type col-sm-9">
            {buildPricingSection(paymentType)}
        </div>
    );

    const paymentTitleKey = isRelated ? 'step4RelatedPaymentTitle' : 'step4paymentTitle';
    const existPaymentSelected = immInsuranceWizardStep.getIn(['pricing', paymentSelected.toLowerCase(), planKeyLowerCase, 'paymentType'])

    if (!existPaymentSelected || isRnc && resetPlan) {
        onhandlePaymentTypeChange(PAYMENT_TYPE.ANNUAL)
    }

    return (
        <div className="row">
            <header className="insurance-request-wizard-step-four__header">
                <FormattedText value={`insuranceRequestHome-${paymentTitleKey}`} />
            </header>
            {isRelated && !isRnc && buildError()}
            <div className={'insurance-request-wizard-step-four__payment-type col-sm-3'}>
                <RadioButtonGroup
                    selectedValue={paymentSelected}
                    onChange={event => onhandlePaymentTypeChange(event)}
                    name="paymentTypeRadioGroup"
                    idPrefix="paymentTypeRadioGroup"
                    label={formatText('insuranceRequestHome-step4paymentType')}
                    className="insurance-request-wizard-step-four__radio-group"
                >
                    {paymentOptions}
                </RadioButtonGroup>
            </div>
            {paymentSectionRelated}
        </div>
    );
}


InsuranceRequestBuildPaymentType.propTypes = {
    paymentSelected: PropTypes.string,
    immInsuranceState: PropTypes.object.isRequired,
    immInsuranceWizardStep: PropTypes.object.isRequired,
    isRelated: PropTypes.bool,
    isRnc: PropTypes.bool,
    onhandlePaymentTypeChange: PropTypes.func.isRequired,
    buildError: PropTypes.func,
    resetPlan: PropTypes.bool,
};

InsuranceRequestBuildPaymentType.defaultProps = {
    paymentSelected: '',
    isRnc: false,
    isRelated: false,
    buildError: () => { },
    resetPlan: false,
};

module.exports = InsuranceRequestBuildPaymentType;